import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
import Screen from "../../components/Screen";
import Team from "../profile/Team";
import { STANDALONE_FEATURES } from "../../utils/standaloneFeatures";
import resolveCompanyId from "../../utils/resolveCompanyId";

const ManageTeamsPage = () => {
  const [query] = useSearchParams();
  const { user, isCompany, isBranchManager, hasBranchId } = useAuth();

  const queryCompanyID = query.get("companyID");
  const queryBranchID = query.get("branchID");
  const isUserReady = Boolean(user?._id);
  const userCompanyID = resolveCompanyId(user?.companyID);
  const userBranchID = resolveCompanyId(user?.branchID);

  const resolvedCompanyID =
    resolveCompanyId(queryCompanyID) ||
    userCompanyID ||
    resolveCompanyId(localStorage.getItem("companyID")) ||
    (isCompany ? resolveCompanyId(localStorage.getItem("_id")) : null);

  const branchID = queryBranchID || (hasBranchId ? userBranchID : null);

  const company = useMemo(
    () => (resolvedCompanyID ? { _id: resolvedCompanyID } : null),
    [resolvedCompanyID],
  );

  const activeTab = "#profile-manage-team";

  return (
    <Screen
      loading={!isUserReady || !resolvedCompanyID}
      standaloneTitle={STANDALONE_FEATURES.MANAGE_TEAMS.title}
      flow={[{ label: STANDALONE_FEATURES.MANAGE_TEAMS.title, to: STANDALONE_FEATURES.MANAGE_TEAMS.path }]}
    >
      <section className="section profile">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body pt-3">
                {resolvedCompanyID ? (
                  <Team
                    company={company}
                    tab={activeTab}
                    isManager={isBranchManager}
                    branchID={branchID}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Screen>
  );
};

export default ManageTeamsPage;
